export default {
  firstname: 'Имя',
  lastname: 'Фамилия',
  secondname: 'Отчество',
  nowDate: 'Текущая дата',
  email: 'Эл. адрес'
}
